import { css } from 'styled-components'
// eslint-disable-next-line no-restricted-imports
import get from 'lodash/get'
import { TextProps } from '../types'

const getMaxHeightForLineHeight = <T>(
    lineHeight: string | number,
    numberOfLines: number,
    theme: T
): number => {
    let maxHeight: number
    if (typeof lineHeight === 'string') {
        maxHeight = parseInt(lineHeight) * numberOfLines
    } else {
        let height = get(theme, `lineHeights[${lineHeight}]`, lineHeight)
        if (typeof height === 'string') {
            height = parseInt(height)
        }
        maxHeight = height * numberOfLines
    }
    return maxHeight
}

export const getMaxHeight = <T>(
    lineHeight: number | string | number[] | string[],
    numberOfLines: number,
    theme: T
): number | number[] => {
    if (Array.isArray(lineHeight)) {
        return (lineHeight as (string | number)[]).map((height): number =>
            getMaxHeightForLineHeight(height, numberOfLines, theme)
        )
    }

    return getMaxHeightForLineHeight(lineHeight, numberOfLines, theme)
}

export const numberOfLines = css<Pick<TextProps, 'lineHeight' | 'numberOfLines' | 'maxHeight'>>`
    ${(props): string => {
        if (props.numberOfLines) {
            if (props.numberOfLines === 1) {
                return 'white-space: nowrap; overflow: hidden; text-overflow: ellipsis;'
            }
            if (props.lineHeight) {
                props.maxHeight = getMaxHeight(props.lineHeight, props.numberOfLines, props.theme)
            }
            return `display: -webkit-box; -webkit-line-clamp: ${props.numberOfLines}; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis;`
        }
        return ''
    }}}
`
